import { mapActions } from "vuex";

export default {
    methods: {
        ...mapActions({
            saveAll: 'crudStore/saveAll',
            assignDataForm: 'crudStore/assignDataForm',
        }),
        async saveForm(event) {
            try {
                if (event.ftn !== undefined) {
                    switch (event.ftn) {
                        case 'guardarFtn':
                            // asigna los check de dataMultiple a servicios_Activos
                            for (let i = 0; i < this.dataMultiple[this.namePath].multiple_servicios.length; i++) {
                                if (this.dataMultiple[this.namePath].multiple_servicios[i].check === 1) {
                                    let newValue = this.deepCopy(this.dataMultiple[this.namePath].multiple_servicios[i])
                                    newValue.id = null
                                    newValue.mes_periodo = this.dataForm[this.namePath].info_afiliacion.mes_periodo
                                    newValue.ano_periodo = this.dataForm[this.namePath].info_afiliacion.ano_periodo
                                    if (this.dataMultiple[this.namePath].multiple_servicios[i].name !== 'Traslado') {
                                        await this.pushDataForm({ state: 'servicios_activos', data: newValue })
                                    } else {
                                        newValue.iniciolabores = null
                                        newValue.mes_periodo = null
                                        newValue.ano_periodo = null
                                        await this.pushDataForm({ state: 'servicios_nuevos', data: newValue })
                                    }

                                }
                            }

                            // se actualizan datos de info_Afiliacion y afiliacion_registro
                            let info_afiliacion = {
                                id: null,
                                id_list_users: this.user.id,
                                fecha: this.fecha().fecha.minHoy,
                                salariobase: this.dataForm[this.namePath].info_afiliacion.salario,
                            }

                            const await1 = this.assignDataForm({ state: 'info_afiliacion', data: info_afiliacion })

                            let afiliacion_registro = {
                                valor: 0,
                                comision: 0,
                                reporte: 0,
                                id_info_ingresos: 0,
                                fecha: this.fecha().fecha.minHoy,
                                id_datos_razon: this.dataForm[this.namePath].info_afiliacion.id_datos_razon,
                                id_datos_asesor: this.dataForm[this.namePath].info_afiliacion.id_datos_asesor,
                                servicios: this.dataForm[this.namePath].servicios_activos
                            }

                            const await2 = this.assignDataForm({ state: 'afiliacion_registro', data: afiliacion_registro })

                            var name = this.dataForm[this.namePath].datos_afiliado.nombre1 + ' ' + this.dataForm[this.namePath].datos_afiliado.nombre2 + ' ' + this.dataForm[this.namePath].datos_afiliado.apellido1 + ' ' + this.dataForm[this.namePath].datos_afiliado.apellido2
                            var re = /null/gi;

                            let datos_afiliado = datos_afiliado = {
                                name: name.replace(re, ' '),
                                id_list_estado: 1
                            }

                            const await3 = this.assignDataForm({ state: 'datos_afiliado', data: datos_afiliado })
                            const await4 = this.updateDataPost({ state: 'route', data: 'save_all' })
                            const await5 = this.updateDataPost({ state: 'tablaDelete', data: [] })
                            const await6 = this.updateDataPost({ state: 'data', data: [] })

                            let descuentos_referidos = {}
                            if (this.dataForm[this.namePath].datos_afiliado.referido !== null) {
                                descuentos_referidos.id = null
                                descuentos_referidos.referido = { name: name.replace(re, ' '), documento: this.dataForm[this.namePath].datos_afiliado.documento }
                                descuentos_referidos.id_datos_afiliado = this.dataForm[this.namePath].datos_afiliado.referido.id
                                descuentos_referidos.id_info_afiliacion = null,
                                    descuentos_referidos.descuento = this.dataForm[this.namePath].descuentos_referido.descuento

                                this.updateDataForm({ state: 'descuentos_referido', data: descuentos_referidos })
                                await this.updateDataPost({ state: 'tablaPost', data: ['datos_afiliado', 'info_afiliacion', 'afiliacion_registro', 'servicios_nuevos', 'servicios_activos', 'descuentos_referido'] })
                            } else {
                                await this.updateDataPost({ state: 'tablaPost', data: ['datos_afiliado', 'info_afiliacion', 'afiliacion_registro', 'servicios_nuevos', 'servicios_activos'] })
                            }
                            // se configura el dataPost	

                            await Promise.all([await1, await2, await3, await4, await5, await6])
                            break;

                    }
                }

                await this.save(event.save)


                await this.resetDataForm()
                await this.onInit()
                const await21 = this.updateCrud({ state: 'dataMultiple/' + this.namePath + '/multiple_servicios', data: this.predeterminados[this.namePath].multiple_servicios })
                const await23 = this.resetGlobal({ state: 'saveConfig/capa' })
                const await24 = this.resetGlobal({ state: 'saveConfig/saveloading' })
                await Promise.all([await21, await23, await24])

                return true

            } catch (e) {
                console.log(e)
            }
        }
    },
}